<template>
  <v-container>
    <ListView :with-sites="false" :color="'#538DCB'" :items="tags" :title-field="'name'">
    </ListView>
  </v-container>
</template>

<script>
import ListView from '@/components/ListView'

export default {
  name: 'index',
  components: { ListView },
  data() {
    return {
      tags: [],
    }
  },
  mounted() {
    this.updateData()
  },
  methods: {
    updateData() {
      this.axios({
        url: '/v1/tags/list',
        method: 'get',
      })
        .then((resp) => {
          this.tags = resp.data
        })
        .catch((err) => {
          this.$log.debug('tags get error', err)
          this.showSnackbar(err.response ? err.response.data : err, 'error')
        })
    },
  },
}
</script>
